import { onlyDigits } from '@shared/lib/validation/documents'

export function formatCPF(value: string): string {
  const digits = onlyDigits(value).slice(0, 11)
  return digits
    .replace(/^(\d{3})(\d)/, '$1.$2')
    .replace(/^(\d{3})\.(\d{3})(\d)/, '$1.$2.$3')
    .replace(/\.(\d{3})(\d)/, '.$1-$2')
}

export function formatCNPJ(value: string): string {
  const digits = onlyDigits(value).slice(0, 14)
  return digits
    .replace(/^(\d{2})(\d)/, '$1.$2')
    .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
    .replace(/\.(\d{3})(\d)/, '.$1/$2')
    .replace(/(\d{4})(\d)/, '$1-$2')
}

export function formatDocument(value: string): string {
  return onlyDigits(value).length > 11 ? formatCNPJ(value) : formatCPF(value)
}

export function formatPhone(value: string): string {
  const digits = onlyDigits(value).slice(0, 15)
  if (digits.length <= 10) {
    return digits.replace(/^(\d{2})(\d)/, '($1) $2').replace(/(\d{4})(\d)/, '$1-$2')
  }
  return digits.replace(/^(\d{2})(\d)/, '($1) $2').replace(/(\d{5})(\d)/, '$1-$2')
}

export function formatPhoneForCountry(value: string, country: 'BR' | 'US'): string {
  const digits = onlyDigits(value)

  if (country === 'BR') {
    const nationalDigits =
      digits.startsWith('55') && (digits.length === 12 || digits.length === 13)
        ? digits.slice(2)
        : digits
    return formatPhone(nationalDigits)
  }

  const nationalDigits = digits.length === 11 && digits.startsWith('1') ? digits.slice(1) : digits
  return nationalDigits
    .slice(0, 10)
    .replace(/^(\d{3})(\d)/, '($1) $2')
    .replace(/(\d{3})(\d)/, '$1-$2')
}

export function formatCEP(value: string): string {
  return onlyDigits(value)
    .slice(0, 8)
    .replace(/^(\d{5})(\d)/, '$1-$2')
}

export function formatZipCode(value: string): string {
  const digits = onlyDigits(value).slice(0, 9)
  if (digits.length <= 5) return digits
  return digits.replace(/^(\d{5})(\d)/, '$1-$2')
}

export function formatPostalCode(value: string, country: 'BR' | 'US'): string {
  return country === 'BR' ? formatCEP(value) : formatZipCode(value)
}
